var _excluded = ["variant", "content", "link", "linkLabel", "local", "children", "className", "data-testid"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { TooltipElement, Wrapper, TooltipContainer, Link, Content } from './Tooltip.style';
import { useTooltip } from './useTooltip';

var Tooltip = _ref => {
  var {
    variant = 'dark',
    content = 'text',
    link = '',
    linkLabel,
    local = 'over',
    children,
    className,
    'data-testid': dataTestId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    focus,
    blurred,
    focused
  } = useTooltip();
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    onFocus: focused,
    onBlur: blurred,
    focus: focus,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TooltipContainer, {
    className: "tooltip-class",
    "data-testid": "".concat(dataTestId, "-tooltip-container"),
    local: local
  }, /*#__PURE__*/React.createElement(TooltipElement, _extends({}, props, {
    variant: variant
  }), /*#__PURE__*/React.createElement(Content, {
    variant: variant
  }, content), /*#__PURE__*/React.createElement(Link, {
    variant: variant,
    href: link
  }, linkLabel || link))), children);
};

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map